import { Box } from "@repo/components/src/ui/box";
import { HStack } from "@repo/components/src/ui/hstack";
import { Icon } from "@repo/components/src/ui/icon";
import { Text } from "@repo/components/src/ui/text";
import { VStack } from "@repo/components/src/ui/vstack";
import type { LucideIcon } from "lucide-react-native";
import React from "react";

type Props = {
  icon: LucideIcon;
  label: string;
  value: string;
  isLast?: boolean;
};

/** Ported from `apps/mobil/.../terms/TermRow.tsx`. */
const TermRow = React.memo(({ icon, label, value, isLast = false }: Props) => (
  <Box className={`px-4 py-3 ${isLast ? "" : "border-b border-outline-50"}`}>
    <HStack space="md" className="items-start">
      <Box className="rounded-xl items-center justify-center w-9 h-9 bg-brand-50">
        <Icon as={icon} size="sm" className="text-brand-400" />
      </Box>
      <VStack className="flex-1" space="xs">
        <Text
          bold
          size="2xs"
          className="uppercase tracking-widest text-typography-500"
        >
          {label}
        </Text>
        <Text bold className="text-typography-950 text-[15px] tracking-tight">
          {value}
        </Text>
      </VStack>
    </HStack>
  </Box>
));

TermRow.displayName = "TermRow";

export default TermRow;
